export default "__VITE_ASSET__fc7bd57a__"